import { styled, Box, Typography, InputAdornment } from '@mui/material'
import moment from 'moment'
import { Icon } from 'packages/eid-icons'
import { MUIDatePicker } from 'packages/eid-ui/DateTimePickers'
import { isNilOrEmpty } from 'packages/core'

const Container = styled(Box)({
    height: '40px',
    width: '100%',
    fontSize: '14px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 15px',
    position: 'relative',
})

const DateTimeFilter = ({
    label,
    showLabelWithin,
    value,
    placeholder,
    onChange,
    minDate,
    disablePast,
    disabled,
    handleClear,
}) => {
    const InputComponent = () => {
        return (
            <Container className="Input-Container">
                <MUIDatePicker
                    dateFormat="D MMMM YYYY"
                    handleChange={(e) => {
                        if (isNilOrEmpty(e)) {
                            handleClear()
                        } else {
                            const date = moment(e)
                            onChange(date)
                        }
                    }}
                    value={value}
                    minDate={
                        minDate
                            ? minDate
                            : disablePast
                            ? moment(new Date())
                            : null
                    }
                    disabled={disabled}
                    customComponents={{
                        inputAdornment: () => {
                            return (
                                <InputAdornment position="end">
                                    {value && (
                                        <Icon
                                            name="Close"
                                            color="#959598"
                                            onClick={() => handleClear()}
                                            style={{
                                                cursor: 'pointer',
                                                marginRight: '1.2rem',
                                            }}
                                        />
                                    )}
                                    <Icon name="Date" color="#D8D8DD" />
                                </InputAdornment>
                            )
                        },
                    }}
                    fieldProps={{
                        variant: 'outlined',
                        sx: {
                            marginTop: '0px !important',
                            '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                            },
                        },
                        placeholder: placeholder,

                        InputProps: {
                            sx: {
                                height: '3.8rem !important',
                                fontSize: '1.6rem !important',
                            },
                        },
                        inputProps: {
                            style: {
                                color: '#5d6870',
                            },
                            readOnly: 'true',
                        },
                    }}
                ></MUIDatePicker>
            </Container>
        )
    }

    const InputWithLabel = () => {
        return (
            <Box>
                <Typography
                    style={{
                        color: '#b4b4b4',
                        fontSize: '10px',
                        textTransform: 'uppercase',
                        minWidth: '60px',
                        padding: '10px 10px',
                    }}
                >
                    {label}
                </Typography>
                <MUIDatePicker
                    dateFormat="D MMMM YYYY"
                    handleChange={(e) => {
                        if (isNilOrEmpty(e)) {
                            handleClear()
                        } else {
                            const date = moment(e)
                            onChange(date)
                        }
                    }}
                    value={value}
                    minDate={
                        minDate
                            ? minDate
                            : disablePast
                            ? moment(new Date())
                            : null
                    }
                    disabled={disabled}
                    customComponents={{
                        inputAdornment: () => {
                            return (
                                <InputAdornment position="end">
                                    {value && (
                                        <Icon
                                            name="Close"
                                            color="#959598"
                                            onClick={() => handleClear()}
                                            style={{
                                                cursor: 'pointer',
                                                marginRight: '1.2rem',
                                            }}
                                        />
                                    )}
                                </InputAdornment>
                            )
                        },
                    }}
                    fieldProps={{
                        variant: 'outlined',
                        style: {
                            width: '100%',
                            borderRadius: '5px',
                            color: '#5d6870 !important',
                        },
                        sx: {
                            '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                            },
                        },
                        placeholder: placeholder,

                        InputProps: {
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Icon name="Calendar" color="#959598" />
                                </InputAdornment>
                            ),
                            sx: {
                                height: '4.0rem !important',
                                fontSize: '1.6rem !important',
                            },
                        },
                        inputProps: {
                            style: {
                                color: '#5d6870',
                                paddingLeft: '10px',
                            },
                            readOnly: 'true',
                        },
                    }}
                ></MUIDatePicker>
            </Box>
        )
    }

    return <>{showLabelWithin ? <InputComponent /> : <InputWithLabel />}</>
}

export default DateTimeFilter
